import React from 'react'
import { useStyles } from './SubscriptionEntitlement.styles'
import { TableComponentV2 } from '@labrav/react-components'
import { Typography, Grid } from '@mui/material'
import {
  Subscription,
  EntitlementSubs,
} from '../../../../modules/subscription/reducer'
import { dateAndTimeConversion } from '../../../../common/utils/dateAndTimeConversion'
import { useSelector } from '../../../../store'
import { DetailedSubscription } from '../../DetailedSubscription/DetailedSubscription'
import { isNonEmptyNumber } from '@labrav/common'

export const SubscriptionEntitlement = (props: {
  flexiblePayment: boolean
  entitlements: EntitlementSubs[]
  subscription: Subscription
}) => {
  const { flexiblePayment, entitlements, subscription } = props
  const entitlementMapping = {
    Dimensions: 'dimensionLabel',
    'Expiry date': 'expirationDate',
    Quantity: 'quantity',
    ...(flexiblePayment === true ? {} : { Price: 'price' }),
  }
  const { classes } = useStyles()

  const timeZone = useSelector<string>(
    state =>
      state.userProfile.userProfile.timeZone ||
      state.userProfile.userProfile.defaultTimeZone ||
      'UTC'
  )

  const entitlementObject = entitlements.map(entitlementDetailItem => ({
    dimensionLabel: (
      <Typography className={classes.value}>
        {entitlementDetailItem.dimensionLabel
          ? entitlementDetailItem.dimensionLabel
          : '-'}
      </Typography>
    ),
    expirationDate: (
      <Typography className={classes.value}>
        {entitlementDetailItem.expirationDate
          ? dateAndTimeConversion(
              entitlementDetailItem.expirationDate,
              timeZone
            ).modifiedDate
          : '-'}
      </Typography>
    ),
    quantity: (
      <Typography className={classes.value}>
        {entitlementDetailItem.value ? entitlementDetailItem.value : '-'}
      </Typography>
    ),
    price: (
      <Typography className={classes.value}>
        {isNonEmptyNumber(entitlementDetailItem.price)
          ? `$${entitlementDetailItem.price}`
          : '-'}
      </Typography>
    ),
  }))
  return (
    <div className={classes.root}>
      <span className={classes.heading}>Entitlements</span>
      <div className={classes.firstDiv}>
        <Grid container spacing={0} className={classes.tableGridComponent}>
          <div className={classes.firstInnerDiv}>
            <TableComponentV2
              keyName={'entitlementsData'}
              objects={entitlementObject}
              mapping={entitlementMapping}
              selectedItem={[]}
              onChangeCheckbox={() => void 0}
              showCheckbox={false}
              isBasicTable={true}
              count={0}
              fetchMoreData={() => void 0}
            />
          </div>
        </Grid>
      </div>
      <div className={classes.secondDiv}>
        <Grid container spacing={0} className={classes.tcvGridComponent}>
          <Grid
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label={'TCV'}
              value={
                isNonEmptyNumber(subscription.tcv)
                  ? `$${subscription.tcv}`
                  : '-'
              }
              subValue=""
            />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
